<template>
    <div>
      <div @change=""></div>
      <a id="downlink"></a>
    </div>
</template>

<script>
  import XLSX from '../../static/xslx'
  export default {
        name: "ExcelDaoChu",
      props:{
        myName:String, //文件名
        myTitle:Array,//文件名
        myData:Array,//定义值和值的类型
        myClick:Boolean//定义值和值的类型
      },
      mounted(){
        this.outFile = document.getElementById('downlink')
      },
      data(){
          return{
            excelData: [],
            outFile: [],  // 导出文件el
          }
      },
      watch:{
        myClick() {
          if(this.myClick){
            this.sureExcel()
          }
        },
      },
      methods:{
        sureExcel(){
          let rs=this.myData
          let data = [{}]
          for (let k in rs[0]) {
            data[0][k] = k
          }
          data = data.concat(rs)
          this.downloadExl(data, this.myName)
        },
        downloadExl: function (json, downName, type) {  // 导出到excel
          let keyMap = [] // 获取键
          for (let k in json[0]) {
            keyMap.push(k)
          }
          // keyMap=['订单编号','下单时间','状态','实际金额','用户名','使用产品名','电话']
          console.info('keyMap', keyMap, json)
          let tmpdata = [] // 用来保存转换好的json
          json.map((v, i) => keyMap.map((k, j) => Object.assign({}, {
            v: v[k],
            position: (j > 25 ? this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
          }))).reduce((prev, next) => prev.concat(next)).forEach(function (v) {
            tmpdata[v.position] = {
              v: v.v
            }
          })
          // let nameData=['订单编号','用户名','状态','使用产品名','实际金额','下单时间','手机号']
          let nameData=this.myTitle
          console.log(nameData)
          for (let k in nameData){
            tmpdata[String.fromCharCode(65+parseInt(k))+1]['v']=nameData[k]
          }
          // tmpdata['A1']['v']='订单编号'
          // tmpdata['B1']['v']='用户名'
          let outputPos = Object.keys(tmpdata)  // 设置区域,比如表格从A1到D10
          let tmpWB = {
            SheetNames: ['mySheet'], // 保存的表标题
            Sheets: {
              'mySheet': Object.assign({},
                tmpdata, // 内容
                {
                  '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
                })
            }
          }
          let tmpDown = new Blob([this.s2ab(XLSX.write(tmpWB,
            {bookType: (type === undefined ? 'xlsx' : type), bookSST: false, type: 'binary'} // 这里的数据是用来定义导出的格式类型
          ))], {
            type: ''
          })  // 创建二进制对象写入转换好的字节流
          var href = URL.createObjectURL(tmpDown)  // 创建对象超链接
          this.outFile.download = downName + '.xlsx'  // 下载名称
          this.outFile.href = href  // 绑定a标签
          this.outFile.click()  // 模拟点击实现下载
          console.log(href)
          setTimeout(function () {  // 延时释放
            URL.revokeObjectURL(tmpDown) // 用URL.revokeObjectURL()来释放这个object URL
          }, 10000)
        },
        s2ab: function (s) { // 字符串转字符流
          var buf = new ArrayBuffer(s.length)
          var view = new Uint8Array(buf)
          for (var i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF
          }
          return buf
        },
        getCharCol: function (n) { // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
          let s = ''
          let m = 0
          while (n > 0) {
            m = n % 26 + 1
            s = String.fromCharCode(m + 64) + s
            n = (n - m) / 26
          }
          return s
        },
        fixdata: function (data) {  // 文件流转BinaryString
          var o = ''
          var l = 0
          var w = 10240
          for (; l < data.byteLength / w; ++l) {
            o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
          }
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
          return o
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ExcelDaoChu.vue